import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-period-select-component',
  templateUrl: './periodSelect.component.html',
  styleUrls: ['./periodSelect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PeriodSelectComponent),
      multi: true,
    },
  ],
})
export class PeriodSelectComponent implements ControlValueAccessor {
  period: string;

  private propagateChange = (_: any) => { };

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  private propagateTouch = (_: any) => { };

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  writeValue(value: string) {
    this.period = value;
  }

  onPeriodChecked(period: string): void {
    this.propagateChange(period);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/PeriodSelectComponent/periodSelect.component.ts